module.exports = __webpack_public_path__ + "img/5-4.a70e0c2c.svg";